// String.fromCharCode(...) overflows the argument limit for large inputs, so bytes are chunked.
const FROM_CHAR_CODE_CHUNK = 0x8000;

export function bytesToBase64(bytes: Uint8Array): string {
    const binary = Array.from(
        { length: Math.ceil(bytes.length / FROM_CHAR_CODE_CHUNK) },
        (_, chunkIndex) =>
            String.fromCharCode(
                ...bytes.subarray(
                    chunkIndex * FROM_CHAR_CODE_CHUNK,
                    (chunkIndex + 1) * FROM_CHAR_CODE_CHUNK,
                ),
            ),
    ).join('');
    return btoa(binary);
}

export function utf8ToBase64(input: string): string {
    return bytesToBase64(new TextEncoder().encode(input));
}

export function base64ToUtf8(encoded: string): string {
    const binary = atob(encoded);
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}
